import { RouteType } from '@/Routes';
import { lazy } from 'react';

const MyPlanIndex = lazy(() => import('@/pages/myplan'));
const MyPlanCards = lazy(() => import('@/pages/myplan/cards'));
const MyPlanPaid = lazy(() => import('@/pages/myplan/paid'));
const RegisterPlan = lazy(() => import('@/pages/myplan/register/[plan]'));

const ServerMyPlan: RouteType[] = [
  { path: '/myplan', component: MyPlanIndex, title: '定期課金設定' },
  { path: '/myplan/paid', component: MyPlanPaid },
  {
    path: '/myplan/register/:plan(light|basic_30|basic_90|basic_180|basic_360|premium|instagram)',
    component: RegisterPlan,
  },
  {
    path: '/myplan/cards',
    component: MyPlanCards,
  },
];

export default ServerMyPlan;
